import { hasItem, itemById } from "@zend/content";

export interface InventoryStack { itemId: string; qty: number }
export const INVENTORY_CATEGORIES = ["all", "xp", "resources", "speedups", "recruitment", "equipment", "boosts", "tokens", "other"] as const;
export type InventoryCategory = typeof INVENTORY_CATEGORIES[number];

export function stockCategory(itemId: string): InventoryCategory {
  if (!hasItem(itemId)) return "other";
  switch (itemById(itemId).kind) {
    case "xp": return "xp";
    case "resource_crate": case "chest": return "resources";
    case "speedup": return "speedups";
    case "fab": case "ffab": case "fragment": case "ufr": return "recruitment";
    case "cdc": case "nano": case "blueprint": case "drone_core": return "equipment";
    case "stamina": case "shield": case "teleport": case "sweep": return "boosts";
    case "token": return "tokens";
    default: return "other";
  }
}

/** Item balances are the only spendable XP stock; a unit's accumulated XP is separate. */
export function xpStock(inventory: readonly InventoryStack[]): { xp: number; boxes: number } {
  return inventory.reduce((sum, row) => {
    if (row.qty <= 0 || !hasItem(row.itemId)) return sum;
    const item = itemById(row.itemId);
    return item.kind === "xp" ? { xp: sum.xp + row.qty * Number(item.params["xp"]), boxes: sum.boxes + row.qty } : sum;
  }, { xp: 0, boxes: 0 });
}

export function sealedResources(inventory: readonly InventoryStack[]): Record<string, number> {
  const result: Record<string, number> = {};
  for (const row of inventory) {
    if (row.qty <= 0 || !hasItem(row.itemId)) continue;
    const item = itemById(row.itemId);
    if (item.kind === "resource_crate") {
      const resource = String(item.params["resource"]);
      result[resource] = (result[resource] ?? 0) + row.qty * Number(item.params["amount"]);
    }
  }
  return result;
}
